import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconSkipForward = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.1962 4.21871L17.9534 2.21593L19.7629 2L20.3291 6.67163C20.3583 6.91269 20.2886 7.15529 20.1356 7.3448C19.9827 7.53432 19.7593 7.65483 19.5159 7.67921L15.0009 8.13128L14.8179 6.33205L17.5654 6.05695C16.1047 4.72698 14.1589 3.91635 12.0237 3.91635C7.49687 3.91635 3.82249 7.56227 3.82249 12.054C3.82249 16.5457 7.49687 20.1916 12.0237 20.1916C15.2374 20.1916 18.0237 18.3541 19.3689 15.676L21 16.4827C19.3587 19.7502 15.9556 22 12.0237 22C6.49034 22 2 17.5444 2 12.054C2 6.56354 6.49034 2.10798 12.0237 2.10798C14.3517 2.10798 16.4948 2.89708 18.1962 4.21871Z",
		fill: "black"
	})
});
export default SvgIconSkipForward;
